import { jsx as _jsx } from "react/jsx-runtime";
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import DesktopAccountCreditsTableRow from './desktop';
import MobileAccountCreditsTableRow from './mobile';
var AccountCreditsTableRow = function (_a) {
    var accountCredit = _a.accountCredit;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    return isLessThanTablet ? (_jsx(MobileAccountCreditsTableRow, { accountCredit: accountCredit })) : (_jsx(DesktopAccountCreditsTableRow, { accountCredit: accountCredit }));
};
export default AccountCreditsTableRow;
//# sourceMappingURL=index.js.map